module.exports = __webpack_public_path__ + "img/sj03.862ae67d.png";